import React from 'react';
import styled from 'styled-components';

type TopBarProps = {
  logoUrl: string;
  corporateAccountName: string;
  period: string;
  year: number;
};

const TopBar = ({
  logoUrl,
  period,
  year,
  corporateAccountName,
}: TopBarProps) => {
  return (
    <Container>
      <LogoArea>
        {logoUrl ? (
          <Logo src={logoUrl} alt="" />
        ) : (
          <LogoPlaceholder>{corporateAccountName}</LogoPlaceholder>
        )}
      </LogoArea>
      <PeriodLabel>
        {period} - {year}
      </PeriodLabel>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 70px 60px;
`;

const LogoArea = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  max-width: 500px;
  max-height: 100px;
  width: auto;
  height: auto;
  object-fit: contain;
`;

const LogoPlaceholder = styled.div`
  width: 272px;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 30px;
  line-height: 30px;
  color: ${({ theme }) => theme.colors.primary};
`;

const PeriodLabel = styled.span`
  font-size: 30px;
  line-height: 20px;
  text-align: center;
`;

export default TopBar;
